import { Typography } from "@mui/material";
import { useEffect } from "react";
import { StyledCardContainer } from "../../styled/CardContainer";
import CircularLoading from "../loading/CircularLoading";

const CardContainer = ({ title, getData, componente, loading, componenteSubtitulo }) => {
  useEffect(() => {
    if (getData) {
      getData();
    }
  }, []);

  return (
    <StyledCardContainer.Card>
      <StyledCardContainer.TitleContainer >
        <Typography variant="h5" component="h2">
          {title}
        </Typography>
      </StyledCardContainer.TitleContainer>
      <>
        {componenteSubtitulo}
      </>
      <StyledCardContainer.CardContent >
        {loading ? <CircularLoading /> : componente}
      </StyledCardContainer.CardContent>
    </StyledCardContainer.Card>
  );
};
export default CardContainer;
